import { useRef } from 'react';
import { ChevronLeft, ChevronRight, ArrowRight } from 'lucide-react';
import { SUCCESS_STORIES_CONFIG } from '../../constants';
import { useLanguage } from '../../hooks/useLanguage';
import { trackEvent } from '../../utils/analytics';
import '../../styles/components/SuccessStories.css';

const SuccessStories = () => {
  const scrollRef = useRef(null);
  const { t } = useLanguage();

  const scroll = direction => {
    if (!scrollRef.current) return;
    const cardWidth = scrollRef.current.querySelector('.story-card')?.offsetWidth || 350;
    const gap = 24;
    const scrollAmount = cardWidth + gap;
    scrollRef.current.scrollBy({
      left: direction === 'left' ? -scrollAmount : scrollAmount,
      behavior: 'smooth',
    });
    trackEvent('carousel_navigate', {
      section: 'success_stories',
      direction,
    });
  };

  return (
    <section id='success-stories' className='success-stories section'>
      <div className='container'>
        <div className='stories-header'>
          <h2 className='stories-title'>{t.successStories.sectionTitle}</h2>
          <p className='stories-subtitle'>{t.successStories.sectionSubtitle}</p>
        </div>

        <div className='stories-carousel-wrapper'>
          <button
            className='carousel-btn carousel-btn-left'
            onClick={() => scroll('left')}
            aria-label={t.successStories.prevButton}
          >
            <ChevronLeft size={24} />
          </button>

          <div className='stories-carousel' ref={scrollRef}>
            {SUCCESS_STORIES_CONFIG.map(story => {
              const texts = t.successStories.items[story.id];
              return (
                <div key={story.id} className='story-card'>
                  <div className='story-image-wrapper'>
                    <picture>
                      <source media='(max-width: 768px)' srcSet={story.imageMobile} />
                      <img
                        src={story.image}
                        alt={texts.imageAlt}
                        className='story-img'
                        loading='lazy'
                      />
                    </picture>
                    <span className='story-category'>{texts.category}</span>
                  </div>
                  <div className='story-content'>
                    <h3 className='story-title'>{texts.title}</h3>
                    <p className='story-description'>{texts.description}</p>
                    <a href={story.link} className='story-link'>
                      {t.successStories.readMore} <ArrowRight size={16} />
                    </a>
                  </div>
                </div>
              );
            })}
          </div>

          <button
            className='carousel-btn carousel-btn-right'
            onClick={() => scroll('right')}
            aria-label={t.successStories.nextButton}
          >
            <ChevronRight size={24} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default SuccessStories;
